<template>
  <div class="app-list-container">
    <div class="app-list">
      <div class="new-entity-section">
        <AppButton @click="openCreate()" label="Novo Usuário" />
      </div>

      <table>
        <tr>
          <th style="width: 20px; max-width: 20px; min-width: 20px;">ID</th>
          <th>Nome</th>
          <th>Email</th>
          <th>Tratamento</th>
          <th>Perfil</th>
          <th>Grupo</th>
          <th>Empresa</th>
          <th>MFA</th>
          <th>Ativo</th>
          <th style="width: 120px; max-width: 120px; min-width: 120px;"></th>
        </tr>
        <tr v-for="data of users" class="table-hover-row">
          <td>{{data.id}}</td>
          <td>{{data.first_name}} {{data.last_name}}</td>
          <td>{{data.email}}</td>
          <td>{{data.treatment}}</td>
          <td>{{data.profile?.name}}</td>
          <td>{{data.group?.name}}</td>
          <td>{{data.company?.name}}</td>
          <td>{{data.enable_mfa_setup ? 'Sim' : 'Não'}}</td>
          <td>{{data.is_active ? 'Sim' : 'Não'}}</td>
          <td style="text-align: right;">
            <a @click="openEdit(data)">Editar</a>
            <a @click="remove(data)" class="delete-action">Excluir</a>
          </td>
        </tr>
      </table>

    </div>
  </div>
</template>

<script>
import { AppButton } from "../../../components";
import {
  userServiceInstance as userService,
  alertServiceInstance as alertService
} from "../../../services";

export default {
  name: "ListUsers",
  components: {
    AppButton
  },
  methods: {
    openCreate() {
      this.$router.push('/users/create');
    },
    openEdit({ id }) {
      this.$router.push(`/users/create?id=${id}`);
    },
    async remove({ id }) {
      await userService.deleteById(id);
      alertService.success({ desc: 'Usuário excluído!' });
      await this.load();
    },
    async load() {
      const data = (await userService.findAll()) ?? [];
      this.users.splice(0, this.users.length);
      this.users.push(...data);
    }
  },
  data: () => ({
    users: []
  }),
  async mounted() {
    await this.load();
  }
}
</script>

<style scoped lang="scss">

</style>